import { render, staticRenderFns } from "./RiderIndicators.vue?vue&type=template&id=136b96fb&"
import script from "./RiderIndicators.vue?vue&type=script&lang=js&"
export * from "./RiderIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports